import React from 'react';
import { Card, CardContent } from '../ui/card';
import { User } from 'lucide-react';

const SeriesAuthor = ({ series }) => {
  const { author } = series;
  
  return (
    <section id="author" className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <Card className="border-0 shadow-2xl overflow-hidden">
            <CardContent className="p-0">
              <div className="grid md:grid-cols-5">
                {/* Author image/placeholder */}
                <div className="md:col-span-2 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-8 flex items-center justify-center relative">
                  {/* Decorative elements */}
                  <div 
                    className="absolute top-4 left-4 w-20 h-20 border rounded-lg opacity-30" 
                    style={{ borderColor: series.accentColor }}
                  />
                  <div 
                    className="absolute bottom-4 right-4 w-16 h-16 border rounded-full opacity-30"
                    style={{ borderColor: series.accentColor }}
                  />
                  
                  <div className="relative z-10 text-center">
                    <div 
                      className="w-32 h-32 bg-slate-700 rounded-full mx-auto mb-6 flex items-center justify-center border-4"
                      style={{ borderColor: `${series.accentColor}50` }}
                    >
                      {author.image ? (
                        <img src={author.image} alt={author.name} className="w-full h-full rounded-full object-cover" />
                      ) : (
                        <User className="w-16 h-16 text-slate-500" />
                      )}
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-1">{author.name}</h3>
                    <p style={{ color: series.accentColor }} className="text-sm">Author & Leadership Expert</p>
                  </div>
                </div>

                {/* Author bio */}
                <div className="md:col-span-3 p-8 lg:p-12">
                  <div 
                    className="text-sm font-semibold mb-2 tracking-wider uppercase"
                    style={{ color: series.accentColor }}
                  >
                    About the Author
                  </div>
                  <h2 className="text-3xl font-bold text-slate-900 mb-6">
                    Meet {author.name}
                  </h2>
                  <p className="text-slate-600 leading-relaxed text-lg">
                    {author.bio}
                  </p>
                  
                  <div className="mt-8 pt-6 border-t border-slate-100">
                    <div className="flex items-center gap-6">
                      <div>
                        <div className="text-2xl font-bold" style={{ color: series.accentColor }}>30+</div>
                        <div className="text-sm text-slate-500">Years Experience</div>
                      </div>
                      <div className="w-px h-12 bg-slate-200" />
                      <div>
                        <div className="text-2xl font-bold" style={{ color: series.accentColor }}>{series.books.length}</div>
                        <div className="text-sm text-slate-500">Books in Series</div>
                      </div>
                      <div className="w-px h-12 bg-slate-200" />
                      <div>
                        <div className="text-2xl font-bold" style={{ color: series.accentColor }}>30</div>
                        <div className="text-sm text-slate-500">Days per Book</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default SeriesAuthor;
